import { defineMessages } from 'react-intl';
var messages = defineMessages({
  rateContentTitle: {
    id: "LessonReviewModal.rateContentTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Rate this content"
    }]
  },
  rateContentHeading: {
    id: "LessonReviewModal.rateContentHeading",
    defaultMessage: [{
      "type": 0,
      "value": "Help improve the learning experience by giving your opinion."
    }]
  },
  interestingQuestion: {
    id: "LessonReviewModal.interestingQuestion",
    defaultMessage: [{
      "type": 0,
      "value": "Was this interesting?"
    }]
  },
  challengingQuestion: {
    id: "LessonReviewModal.challengingQuestion",
    defaultMessage: [{
      "type": 0,
      "value": "How challenging was this?"
    }]
  },
  competentQuestion: {
    id: "LessonReviewModal.competentQuestion",
    defaultMessage: [{
      "type": 0,
      "value": "How competent did you feel?"
    }]
  },
  submitRatingLabel: {
    id: "LessonReviewModal.submitRatingLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Submit rating"
    }]
  },
  updateRatingLabel: {
    id: "LessonReviewModal.updateRatingLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Update rating"
    }]
  },
  easyLabel: {
    id: "LessonReviewModal.easyLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Easy"
    }]
  },
  difficultLabel: {
    id: "LessonReviewModal.difficultLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Difficult"
    }]
  },
  noviceLabel: {
    id: "LessonReviewModal.noviceLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Novice"
    }]
  },
  expertLabel: {
    id: "LessonReviewModal.expertLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Expert"
    }]
  },
  noLabel: {
    id: "General.noLabel",
    defaultMessage: [{
      "type": 0,
      "value": "No"
    }]
  },
  yesLabel: {
    id: "General.yesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Yes"
    }]
  },
  leaveRatingSuccess: {
    id: "LessonReviewModal.leaveRatingSuccess",
    defaultMessage: [{
      "type": 0,
      "value": "Thank you for rating the content!"
    }]
  }
});
export default messages;